import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

export const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Not found | Eluve</title>
      </Helmet>
      <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-text-accent-primary">
            404
          </p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-text-primary sm:text-5xl">
            Page not found
          </h1>
          <p className="mt-6 text-base leading-7 text-text-secondary">
            Sorry, we couldn’t find the page you’re looking for.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              to="/"
              className="rounded-md bg-bg-accent-strong-secondary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-bg-accent-strong-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-accent-quaternary"
            >
              Go back home
            </Link>
          </div>
        </div>
      </main>
    </>
  );
};
